(function () {
  'use strict';

  document.querySelectorAll('.hero-banners-custom').forEach(initHero);

  function initHero(section) {

    const viewport = section.querySelector('.hbc__viewport');
    const track    = section.querySelector('.hbc__track');
    const dots     = Array.from(section.querySelectorAll('.hbc__dot'));
    const prevBtn  = section.querySelector('.hbc__arrow--prev');
    const nextBtn  = section.querySelector('.hbc__arrow--next');

    const all        = Array.from(track.querySelectorAll('.hbc__slide'));
    const realSlides = all.filter(function (s) { return !s.classList.contains('hbc__slide--clone'); });

    if (!realSlides.length) return;

    const GAP            = 24;
    const autoplay       = section.dataset.autoplay === 'true';
    const autoplaySpeed  = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let isTransitioning = false;
    let autoplayTimer   = null;

  
    if (realSlides.length === 1) {
      const center = () => {
        track.style.transition = 'none';
        track.style.transform  = 'translateX(' + ((viewport.offsetWidth - realSlides[0].offsetWidth) / 2) + 'px)';
        void track.offsetHeight;
        track.style.transition = '';
      };
      center();
      new ResizeObserver(center).observe(viewport);
      revealViewport();
      return;
    }

    const totalAll = all.length;
    let current    = 1; 

    function realIdx(i) {
      var n = realSlides.length;
      return ((i - 1) % n + n) % n;
    }

    function slideWidth() { return all[1].offsetWidth; }

    function getOffset(i) {
      return -i * (slideWidth() + GAP) + (viewport.offsetWidth - slideWidth()) / 2;
    }

   
     function jumpTo(i) {
      track.classList.add('hbc__track--jump');
      track.style.transform = 'translateX(' + getOffset(i) + 'px)';
 
      void track.offsetWidth;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          track.classList.remove('hbc__track--jump');
        });
      });
    }

   
    function slideTo(i) {
      track.style.transform = 'translateX(' + getOffset(i) + 'px)';
    }

   
    function activateSlide(i) {
      all.forEach(function (s, idx) {
        var active = idx === i;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', String(!active));
      });

      var ri = realIdx(i);
      dots.forEach(function (dot, idx) {
        var active = idx === ri;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      var bg = all[i].dataset.bgColor;
      if (bg) section.style.setProperty('--hbc-bg', bg);
    }

   
    function loopJumpIfNeeded() {
      if (current === 0) {
        var realLast = totalAll - 2;
        requestAnimationFrame(function () {
          activateSlide(realLast);
          jumpTo(realLast);
          current = realLast;
        });
      } else if (current === totalAll - 1) {
        requestAnimationFrame(function () {
          activateSlide(1);
          jumpTo(1);
          current = 1;
        });
      }
    }

    function onTransitionEnd(e) {
      if (e && e.target !== track) return;   
      if (e && e.propertyName && e.propertyName !== 'transform') return;
      isTransitioning = false;
      loopJumpIfNeeded();
    }

    function goTo(target) {
      if (isTransitioning || target === current) return;
      isTransitioning = true;

      activateSlide(target);
      current = target;

      if (prefersReduced) {
        jumpTo(target);
        isTransitioning = false;
        loopJumpIfNeeded();
        return;
      }

      slideTo(target);
      track.addEventListener('transitionend', onTransitionEnd, { once: true });
      setTimeout(function () {
        if (isTransitioning) {
          track.removeEventListener('transitionend', onTransitionEnd);
          onTransitionEnd();
        }
      }, 700);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    all.forEach(function (slide, i) {
      slide.addEventListener('click', function () {
        if (i !== current) { resetAutoplay(); goTo(i); }
      });
    });

    function startAutoplay() {
      if (!autoplay || prefersReduced) return;
      autoplayTimer = setInterval(next, autoplaySpeed);
    }
    function stopAutoplay()  { clearInterval(autoplayTimer); autoplayTimer = null; }
    function resetAutoplay() { stopAutoplay(); startAutoplay(); }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); resetAutoplay(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); resetAutoplay(); next(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) { e.stopPropagation(); resetAutoplay(); goTo(i + 1); });
    });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); resetAutoplay(); next(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); resetAutoplay(); prev(); }
    });

    var touchX = 0, touchY = 0;
    track.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
      touchY = e.changedTouches[0].clientY;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 44) {
        resetAutoplay();
        dx < 0 ? next() : prev();
      }
    }, { passive: true });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin',    stopAutoplay);
    section.addEventListener('focusout',   startAutoplay);

    document.addEventListener('shopify:block:select', function (e) {
      var idx = realSlides.findIndex(function (s) { return s.dataset.blockId === e.detail.blockId; });
      if (idx >= 0) { stopAutoplay(); goTo(idx + 1); }
    });
    document.addEventListener('shopify:block:deselect', startAutoplay);

    new ResizeObserver(function () { jumpTo(current); }).observe(viewport);

    activateSlide(1);
    jumpTo(1);
    startAutoplay();
    revealViewport();

    function revealViewport() {
      requestAnimationFrame(function () {
        viewport.classList.add('is-ready');
      });
    }

  }

})();